module.exports = __webpack_public_path__ + "img/infrastructure-24.2f24eea7.png";